import BaseModel from "./BaseModel";

type ChatUserTypes = "Student" | "Tutor" | "Liaison" | "Supervisor";
export default class ConversationParticipantModel extends BaseModel {
  userId?: number;
  twillioId: string;
  firstName: string;
  lastName: string;
  middleName: string;
  profilePictureUrl: string;
  userType: ChatUserTypes;

  constructor(data: any) {
    super(data);
    const { user } = data;
    this.userId = user.id;
    this.twillioId = user.twilio_identity;
    this.firstName = user.first_name!;
    this.lastName = user.last_name!;
    this.middleName = user.middle_name!;
    this.userType = user.object_type;
    this.profilePictureUrl =
      user.profile_picture_url ??
      "https://upload.wikimedia.org/wikipedia/commons/4/47/HI_all.png";
  }

  get fullName(): string {
    return `${this.firstName} ${this.middleName} ${this.lastName}`;
  }

  get displayName(): string {
    if (this.isSupervisor) return "Supervisor";
    return `${this.firstName} ${this.lastName}`;
  }

  get isSupervisor(): boolean {
    return this.userType === "Supervisor";
  }

  // static toChatContacts(contacts: ConversationContactModel[]): ChatContact[] {
  //   return contacts.map((contact) => {
  //     return {
  //       name: contact.displayName,
  //       badge: contact.object_type!,
  //       profilePictureUrl: contact.profilePictureUrl,
  //     };
  //   });
  // }
}
